import React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@material-ui/core";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    disableDescription: {
      lineHeight: 1.55,
    },
  })
);

export interface DisableTwoFactorDialogProps {
  open: boolean;
  busy: boolean;
  onClose: () => void;
  onSubmit: () => Promise<void>;
}

export const DisableTwoFactorDialog: React.VFC<DisableTwoFactorDialogProps> = ({
  open,
  busy,
  onClose,
  onSubmit,
}) => {
  const classes = useStyles();

  return (
    <Dialog
      open={open}
      onClose={busy ? undefined : onClose}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>二要素認証の解除</DialogTitle>
      <DialogContent>
        <Typography className={classes.disableDescription}>
          二要素認証を解除しますか？
          <br />
          二要素認証を解除すると、ワンタイムパスワードを使わずにログインできるようになります。
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button color="secondary" onClick={onSubmit} disabled={busy}>
          解除
        </Button>
        <Button onClick={onClose} disabled={busy}>
          キャンセル
        </Button>
      </DialogActions>
    </Dialog>
  );
};
